import React from 'react';
import { ArrowLeft } from 'react-feather';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import { routes } from 'constants/config';

const BackToJourney = ({ journeyId, journeyName, isPreviewing }) => {
  return (
    <a
      className="LessonHeaderBackToPath u-linkBtn d-f ai-c wb-bw"
      href={routes.JOURNEY.RESOURCE(journeyId)}
    >
      <ArrowLeft className="f-sh-0 mr-8" />
      <span className="LessonHeader-pathName wb-ba ws-pr">
        <Text variant={TEXT_VARIANTS.BODY_LINK}>{journeyName}</Text>
      </span>
      <span className="LessonHeader-backLink">
        <Text variant={TEXT_VARIANTS.BODY_LINK}>{t('common.back')}</Text>
      </span>
    </a>
  );
};

export default props => <BackToJourney {...props} />;
